export const educations = [
    {
        "school": "Bowling Green State University (BGSU)",
        "start": "August 2016",
        "end": "May 2018",
        "location": "Bowling Green, Ohio",
        "major": "Master of Computer Science"
    },
    {
        "school": "Shiraz Unversity",
        "start": "September 2010",
        "end": "February 2015",
        "location": "Shiraz, Iran",
        "major": "Bachelor of Software Engineering"
    },
]